// extracted by mini-css-extract-plugin
export default {"WebhookVariablesSections-container":"WebhookVariablesSections-container3peRsA_vpLo8","WebhookVariablesSections-title":"WebhookVariablesSections-title3IsyQ9sulqn1"};